module.exports = __webpack_public_path__ + "static/media/transporter-3.8540a66d.svg";